import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  XOA_HOP_DONG,
  CHECK_XOA_HOP_DONG,
} from "actions/XoaHopDong/actionTypes";
import {
  xoaHopDongSuccess,
  xoaHopDongFailure,
  kiemTraXoaHopDongSuccess,
  kiemTraXoaHopDongFailure,
} from "actions/XoaHopDong";
import XoaHopDongApi from "service/xoaHopDongApi";
import { pushNotification } from "utils/notifications";

function* xoaHopDong(action) {
  try {
    const response = yield call(XoaHopDongApi.xoaHopDong, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        yield put(xoaHopDongSuccess(response.data));
        pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
      } else {
        yield put(xoaHopDongSuccess(response.data));
        pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
        action.callback();
      }
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(xoaHopDongFailure());
    }
  } catch (error) {
    yield put(xoaHopDongFailure());
  }
}

function* kiemTraXoaHopDong(action) {
  try {
    const response = yield call(
      XoaHopDongApi.kiemTraXoaHopDong,
      action.dataPost
    );
    if (response.ok && response.data) {
      yield put(kiemTraXoaHopDongSuccess(response.data.IsDelete));
    } else {
      yield put(kiemTraXoaHopDongFailure());
    }
  } catch (error) {
    yield put(kiemTraXoaHopDongFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(XOA_HOP_DONG, xoaHopDong);
  yield takeLatest(CHECK_XOA_HOP_DONG, kiemTraXoaHopDong);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
